export default "__VITE_ASSET__B$MfHuvM__";